<script lang="ts" setup>
import AppModal from "@/components/AppModal.vue";
import UpdateClientForm from "@/features/clients/UpdateClientForm.vue";
import type { Client } from "~/common/types/types";

const emit = defineEmits(["close", "submitted"]);

const client = defineModel({
  required: true,
  type: Object as PropType<Client>   
})

function submitted(client: Client) {
  emit("submitted", client);
  closed();
}

function closed() {
    emit("close");
}

</script>
<template>
  <AppModal @close="closed">
    <template #title> Update Client </template>
    <template #body>
      <UpdateClientForm @submitted='submitted' v-model="client" />
    </template>
  </AppModal>
</template>